import { Container } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledManageUsersContainer = styled(Container)`
  padding-top: 3rem;
  padding-bottom: 8rem;
`;

export const StyledSearch = styled.div`
  display: flex;
  width: 100%;
  gap: 1.6rem;
  margin-bottom: 2.4rem;
`;

export const StyledTextFieldContainer = styled.div`
  flex: 1;
`;
